import { Component, OnInit, ViewContainerRef, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ImplementToCopy } from '../setup-implement/copy-implement-dialog/copy-implement-dialog.model';
import { Router } from '@angular/router';
import { CustomerSelectItem, JobsiteSelectItem, EquipmentSelectItem } from '../setup-equipment/setup-equipment.model';
import { GenericIdName, SetupImplementErrorCodes, SaveImplementDetailParams, ImplementDetails, GenericIdNameBudgetHours } from '../setup-implement/setup-implement.model';
import { GETSetupEquipmentService } from '../setup-equipment/setup-equipment.service';
import { SetupImplementService } from '../setup-implement/setup-implement.service';
import { AppService } from '../../../app.service';
import { FrontEndComponetService } from '../FECR/front-end-componet.service';
import { ImplementItem } from '../FECR/FECRDashboard/fecr-search-panel/fecr-search-panel.model';
import { NotificationsService } from 'angular2-notifications';
import { DateAdapter } from '@angular/material/core';
@Component({
    selector: 'app-copy-implement',
    templateUrl: './copy-implement.component.html',
    styleUrls: ['./copy-implement.component.scss']
})
export class CopyImplementComponent implements OnInit {

    displayedColumns = [
        'selectImplement', 'implementTypeAndSerial', 'newSerialNo',
        'setupDate', 'implementHoursAtSetup', 'equipmentSMUAtSetup', 'budget_hoursAtSetup', 'Purchased_CostAtSetup', 'status'];
    dataSource = new MatTableDataSource<ImplementToCopy>();

    // User selected parameters
    destEquipment: number = 0;
    destJobsite: number = 0;
    //source
    equipmentOrInventory: number = 1;
    customerList: CustomerSelectItem[] = [];
    jobsiteList: JobsiteSelectItem[] = [];
    equipmentList: EquipmentSelectItem[] = [];
    implementList: GenericIdNameBudgetHours[] = [];

    //destination
    destinationequipmentOrInventory: number = 1;
    destinationCustomer: number;
    destinationJobsite: number;
    destinationEquipment: number;
    destinationImplementType: number;
    destinationImplement:number;
    destinationcustomerList: CustomerSelectItem[] = [];
    destinationjobsiteList: JobsiteSelectItem[] = [];
    destinationequipmentList: EquipmentSelectItem[] = [];
    destinationimplementList: ImplementItem[] = [];
    destinationImplementTypsList: GenericIdName[] = [];
    CopydestinationimplementList: ImplementItem[] = [];




    //model mot match err
    model_match_for_source_desti_eq: boolean = true;
    source_eq_model: string;
    desti_eq_model: string


    // User selections in input boxes
    selectedCustomer: number;
    selectedJobsite: number;
    selectedEquipment: number;
    isCopy: boolean = false;
    // Error codes
    pageErrors: SetupImplementErrorCodes = new SetupImplementErrorCodes();

    constructor(
        private _equipmentService: GETSetupEquipmentService,
        private _implementService: SetupImplementService, private _fecrService: FrontEndComponetService,
        public toastr: NotificationsService, vcr: ViewContainerRef, private _router: Router,
        private _appService: AppService,
        private dateAdapter: DateAdapter<Date>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        
        this.dateAdapter.setLocale('en-GB');
    }

    ngOnInit() {
        this._appService.setPageTitle('Copy Implement Setup');
        //this._appService.setPageSubTitle('');

        this._equipmentService.getCustomerList().subscribe((r: any) => {
            this.customerList = r;
            this.destinationcustomerList = r;
        })
        this.loadImplementsList();
        //console.log("this.data", this.data, "this._router.url", this._router.url)
    }

    loadImplementTypes() {

        this._fecrService.getImplementTypeList().subscribe((r: any) => {

            let arr = []

            if (this.destinationCustomer != null) {
                this.destinationImplementTypsList = r.filter(x => x.CustomerId == this.destinationCustomer);
            }
        });
    }

    loadImplementsList() {
        this._fecrService.GetImplementsAvailable().subscribe(res => {
            this.destinationimplementList = res;
            this.CopydestinationimplementList = res;
        })
    }
    onSelectImplementTypeDestinantion() {
        this.destinationimplementList = this.CopydestinationimplementList;
        console.log("destinationImplementType", this.destinationImplementType, this.destinationimplementList)
        if (this.destinationImplementType == null)
            return

        else {
            this.destinationimplementList = this.destinationimplementList.filter(x => x.Id == this.destinationImplementType);
        }

    }
    /////////////////////////////////
    ///handle destination inputs////
    /////////////////////////////////

    // Show the list of Jobsites for the destination customer.
    loadJobsitesForCustomerDestination() {
        if (this.destinationCustomer == null)
            return;
        this.destinationJobsite = null;
        this.destinationjobsiteList = [];
        this.destinationEquipment = null;
        this.destinationequipmentList = [];
        this._equipmentService.getJobsiteList(this.destinationCustomer).subscribe(r => {
            this.destinationjobsiteList = r;
        });
        this.loadImplementTypes();
    }

    loadEquipmentForJobsiteDestination() {
        if (this.destinationJobsite == null)
            return;
        this._equipmentService.getEquipmentList(this.destinationJobsite).subscribe(r => {
            this.destinationequipmentList = r;
        });
    }

    createInInventoryDestination() {
        // Only proceed if the jobsite is selected.
        if (this.destinationJobsite == null) {
            return;
        }
        if (this.destinationequipmentOrInventory == 1)
            this.destEquipment = this.destinationEquipment;
        else if (this.destinationequipmentOrInventory == 3)
            this.destEquipment = 0;
        else
            this.destEquipment = 0;
    }

    onSelectEquipmentDestinantion() {
        if (this.destinationEquipment != null) {
            //this.loadImplementsForEquipment();

            this.destEquipment = this.destinationEquipment;

            //check destination equipment model
            this._implementService.GetModelDiffMessage(this.selectedEquipment, this.destinationEquipment).subscribe(r => {

                console.log("r", r)
                if (r) {
                    this.model_match_for_source_desti_eq = r.match;
                    this.source_eq_model = r.modelid_source;
                    this.desti_eq_model = r.modelid_dest;
                }
            });
        }


    }


    // loadImplementsForEquipmentDestinantion() {
    //     this._implementService.GetImplementsOnEquipment(this.destinationEquipment).subscribe(r => {
    //         this.destinationimplementList = r;
    //     });
    // }

    /////////////////////////////////
    ///handle Source inputs//////////
    /////////////////////////////////

    // Show the list of Jobsites for the selected customer.
    loadJobsitesForCustomer() {
        if (this.selectedCustomer == null)
            return;
        this.selectedJobsite = null;
        this.jobsiteList = [];
        this.selectedEquipment = null;
        this.equipmentList = [];
        this._equipmentService.getJobsiteList(this.selectedCustomer).subscribe(r => {
            this.jobsiteList = r;
        });
    }

    // If the implement is selected as being on an equipment, 
    // show the list of equipment for that jobsite.
    loadEquipmentForJobsite() {
        if (this.selectedJobsite == null)
            return;
        this._equipmentService.getEquipmentList(this.selectedJobsite).subscribe(r => {
            this.equipmentList = r;
        });
    }

    // Load implements for the selected equipment.
    onSelectEquipment() {
        if (this.selectedEquipment != null) {
            this.loadImplementsForEquipment();

            if (this.destinationEquipment != null) {



                //check destination equipment model
                this._implementService.GetModelDiffMessage(this.selectedEquipment, this.destinationEquipment).subscribe(r => {
                    console.log("r", r)

                    if (r) {
                        this.model_match_for_source_desti_eq = r.match;
                        this.source_eq_model = r.modelid_source;
                        this.desti_eq_model = r.modelid_dest;
                    }

                });
            }
        }
    }

    // Implement is in inventory.
    createInInventory() {
        if (this.equipmentOrInventory == 2) {
            // Only proceed if the jobsite is selected.
            if (this.selectedJobsite == null) {
                return;
            }

            this._implementService.GetImplementsInInventory(this.selectedJobsite).subscribe(r => {
                console.log("GetImplementsInInventory", r)

                if (r.length > 0) {
                    this.implementList = r.filter(x => x.IsTemplate == false);
                }
                this.loadTableOfImplementsForCopy();
            });
        } else if (this.equipmentOrInventory == 3) {
            // Only proceed if the jobsite is selected. 
            if (this.selectedJobsite == null) {
                return;
            }

            this._implementService.GetImplementsInInventory(this.selectedJobsite).subscribe(r => {
                console.log("GetImplementsInInventory", r)
                if (r.length > 0) {
                    this.implementList = r.filter(x => x.IsTemplate == true);
                }
                this.loadTableOfImplementsForCopy();
            });
        }
        else {
            this.loadImplementsForEquipment()
        }
    }

    // Gets the list of implements that are currently loaded on the selected equipment.
    loadImplementsForEquipment() {
        this._implementService.GetImplementsOnEquipment(this.selectedEquipment).subscribe(r => {
            console.log("GetImplementsOnEquipment", r)
            this.implementList = r;
            this.loadTableOfImplementsForCopy();
        });
    }




    // Load the table of implements available to be copied.
    loadTableOfImplementsForCopy() {
        var newList: ImplementToCopy[] = [];
        console.log("implementList", this.implementList)

        for (var i = 0; i < this.implementList.length; i++) {
            var newImplement: ImplementToCopy = {
                selectImplement: false,
                implementId: this.implementList[i].Id,
                implementTypeAndSerial: this.implementList[i].Name,
                newSerialNo: "",
                setupDate: null,
                implementHoursAtSetup: 0,
                equipmentSMUAtSetup: 0,
                status: 0,
                budget_hours: this.implementList[i].Budget_Hours,
                Purchased_Cost: 0
            }

            newList.push(newImplement);
        }
        console.log("newList", newList)

        this.dataSource.data = newList;
    }



    validateNewSerialNo(newSerialNo: string) {
        if (newSerialNo == null || newSerialNo.trim().length == 0) {
            return false;
        }
        return true;
    }

    validateSetupDate(setupDate: string) {
        if (setupDate == null) {
            return false;
        }
        return true;
    }

    validateImplementHoursAtSetup(implementSetupHours) {
        if (implementSetupHours == null || (implementSetupHours === "") || isNaN(implementSetupHours) || implementSetupHours < 0) {
            return false;
        }
        return true;
    }

    validateBudgetHoursAtSetup(budget_hours) {
        if (budget_hours == null || (budget_hours === "") || isNaN(budget_hours) || budget_hours < 0) {
            return false;
        }
        return true;
    }

    validateEquipmentSMU(smu) {
        if (smu == null || (smu == "") || smu < 0) {
            return false;
        } if (smu == 0) {
            return true;
        } else {
            return true;
        }

    }

    // Exit modal by pressing Accept
    onConfirmClick() {
        console.log("this.dataSource.data.length", this.dataSource.data)

        if (this.destinationequipmentOrInventory == 3) {
            let count = 0;
            this.dataSource.data.map(x => {
                if (x.selectImplement == true) {
                    count = count + 1;
                }
            })
            if (count > 1) {
                this.toastr.error("Please select only one Implement.");
                return;

            } if (this.destinationImplement ==null || this.destinationImplement==0) {
                this.toastr.error("Please select exisiting Implement");
                return;

            }
            if(this.dataSource.data.length==0){
                this.toastr.error("Please select implement to copy from");
                return;
            }

            else{
                var implement = this.dataSource.data[0];
                this._implementService.CreateCopyToExisitingImplement(implement.implementId, this.destinationImplement).subscribe(res=>{
                    if(res==true){
                        implement.status = 1;
                        implement.selectImplement = false;
                        this.toastr.success("Successfully Copyed the Implment");
                    }else{
                        this.toastr.error(this.pageErrors.ERROR_SAVING_EXISIING_IMPLEMENT);
                    }
                })
            }
        } else {
            for (var i = 0; i < this.dataSource.data.length; i++) {
                var implement = this.dataSource.data[i];
                if (implement.selectImplement) {
                    var isNewSerialNoEntered = this.validateNewSerialNo(implement.newSerialNo);
                    var isSetupDateEntered = this.validateSetupDate(implement.setupDate);
                    var isImplementSetupHoursEntered = this.validateImplementHoursAtSetup(implement.implementHoursAtSetup);
                    var isBudgetHoursEntered = this.validateBudgetHoursAtSetup(implement.budget_hours);

                    if (!isNewSerialNoEntered) {
                        this.toastr.error("Please enter the serial number.");
                        break;
                    }

                    if (!isSetupDateEntered) {
                        this.toastr.error("Please enter the setup date.");
                        break;
                    }

                    if (!isImplementSetupHoursEntered) {
                        this.toastr.error("Please enter the implement setup hours.");
                        break;
                    }

                    if (!isBudgetHoursEntered) {
                        this.toastr.error("Please enter the Budget setup hours.");
                        break;
                    }

                    if (this.destEquipment > 0) {
                        console.log("SMU", implement.equipmentSMUAtSetup)
                        var isEquipmentSMUEntered = this.validateEquipmentSMU(implement.equipmentSMUAtSetup);
                        if (!isEquipmentSMUEntered) {
                            if (implement.equipmentSMUAtSetup == 0) {

                            } else {
                                this.toastr.error("Please enter the equipment SMU at setup.");
                            }


                        }
                    }

                    this.validateAndCopyImplement(implement);
                }
            }
        }

    }
isCopyToTemplate: boolean=false;
    validateAndCopyImplement(c) {
        var setupDateParts: string;
        if (c.setupDate != null) {
            setupDateParts = c.setupDate.getDate() + "/" + (c.setupDate.getMonth() + 1) + "/" + c.setupDate.getFullYear();
        } else {
            c.status = 0;
        }
        //console.log(setupDateParts);

        // Validate the serial number first and check that it is not being used elsewhere.
        this._implementService.ValidateImplementSerial(0, c.newSerialNo).subscribe(r => {
            if (!r) {
                this.toastr.error(this.pageErrors.ERROR_SERIALNO_VALIDATION_FAILED);
                c.newSerialNo = "";
                c.status = 0;
            } else {
                // Only process if both the existing implement and serial number are entered.
                if (c.selectImplement && c.implementId > 0 && c.setupDate != null && c.newSerialNo.length > 0) {
                    var iDestinationEquipment = 0;
                    if (this.destinationEquipment != null) {
                        iDestinationEquipment = this.destinationEquipment;
                    }
if(this.destinationequipmentOrInventory==4)
this.isCopyToTemplate=true;
                    
                    this._implementService.CreateCopyBasedOnExistingImplement(c.implementId, c.newSerialNo, iDestinationEquipment, this.destinationJobsite,
                        setupDateParts, c.implementHoursAtSetup, c.equipmentSMUAtSetup, c.budget_hours,this.isCopyToTemplate).subscribe(r2 => {
                            if (r2 > 0) {
                                c.status = 1;
                                c.selectImplement = false;
                                //this.toastr.error(this.pageErrors.ERROR_SAVING_SETUP_EVENT);
                                this.toastr.success("Successfully Copied Implement");
                                var params1 = this.createImplementDetailParams();
                                params1.Details.Id = r2//c.implementId;
                                params1.Details.ImplementHoursAtSetup = c.implementHoursAtSetup;
                                params1.Details.SetupDate = setupDateParts;
                                params1.Details.purchaseCost = c.Purchased_Cost;

                                this._implementService.CreateImplementSetupEvent(params1).subscribe(r => {
                                    if (r < 0) {
                                        this.toastr.error(this.pageErrors.ERROR_SAVING_SETUP_EVENT);
                                        

                                        
                                    }
                                });
                            } else {
                                this.toastr.error(this.pageErrors.ERROR_SAVING_SETUP_EVENT);
                                c.status = -1;
                            }
                        });
                } else {
                    this.toastr.error(this.pageErrors.ERROR_SAVING_CHANGES);
                    c.status = 0;
                }


            }
        });



    }

    createImplementDetailParams(): SaveImplementDetailParams {
        var details: ImplementDetails = new ImplementDetails();
        details.Id = 0;
        details.ImplementType = 0;
        details.Make = 0;
        details.SerialNo = "";
        details.SetupDate = "";
        details.ImplementHoursAtSetup = 0;
        details.EquipmentSMUAtSetup = 0;

        var params = new SaveImplementDetailParams();
        params.Details = details;
        params.EquipmentId = this.selectedEquipment;
        params.JobsiteId = this.selectedJobsite;

        return params;
    }
}
